import _has from 'lodash/has';

const itemAction = (item, onItemSelected) => {
  if (!item.disabled) {
    if (onItemSelected) {
      return { onClick: () => onItemSelected(item) };
    }

    if (_has(item, 'options.href')) {
      return { href: item.options.href, target: item.options.target };
    }
  }

  return { onClick: () => {} };
};

export default itemAction;
